export default "__VITE_ASSET__2qQ9sOPC__"